import * as actions from "../Actions/type";

const initSate = {
  cards : []
};

const CardsReducer = (state = initSate, action) => {
  switch (action.type) {

    case actions.GET_SLUG: {
      return { ...state, cards: action.payload };
    }

    case actions.GET_CARDS: {
      return { ...state, cards: action.payload };
    }
    
    case actions.GET_CARD: {
      return { ...state, card: action.payload };
    }

    case actions.CREATE_CARD: {
      return { ...state, cards: [{...action.payload},...state.cards] };
    }

    case actions.EDIT_CARD: {
      let card = action.payload;
      let cards = state.cards.map( c => {
        if(c.id === card.id){
          return {...card}
        }
        return {...c}
      });
      return { ...state, cards: cards};
    }
    
    case actions.USER_DETAIL: {
      let users = state.users.filter( v => v.id !== action.payload);
      return { ...state, users: users };
    }

    case actions.DELETE_CARD: {
      let cards = state.cards.filter( v => v.id !== action.payload);
      return { ...state, cards };
    }
    default:{
      return state;
    }
  }
};

export default CardsReducer;
